import { memo } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { FileText, Download } from "lucide-react";

const FilePreviewDialog = memo(({ open, onClose, file, fileName }) => {
  const isImage = file && file.type && file.type.startsWith("image/");
  const isPDF =
    file &&
    (file.type === "application/pdf" ||
      fileName?.toLowerCase().endsWith(".pdf"));

  const fileSizeMB = file ? (file.size / 1024 / 1024).toFixed(2) : "0.00";

  const handleDownload = () => {
    const url = file && isImage ? URL.createObjectURL(file) : null;
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleOpenPDF = () => {
    const url = URL.createObjectURL(file);
    window.open(url, "_blank");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, color: "#1f2937" }}>
        {fileName}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {isImage ? (
            <Box
              component="img"
              src={URL.createObjectURL(file)}
              sx={{
                width: "100%",
                maxHeight: "500px",
                objectFit: "contain",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
              }}
            />
          ) : isPDF ? (
            <Box
              sx={{
                p: 4,
                backgroundColor: "#f3f4f6",
                borderRadius: "8px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FileText size={64} style={{ color: "#dc2626" }} />
              <Typography variant="body2" sx={{ color: "#6b7280" }}>
                PDF File: {fileName}
              </Typography>
              <Typography variant="caption" sx={{ color: "#6b7280" }}>
                File Size: {fileSizeMB} MB
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                p: 4,
                backgroundColor: "#f3f4f6",
                borderRadius: "8px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FileText size={64} style={{ color: "#6b7280" }} />
              <Typography variant="body2" sx={{ color: "#6b7280" }}>
                File: {fileName}
              </Typography>
              <Typography variant="caption" sx={{ color: "#6b7280" }}>
                File Size: {fileSizeMB} MB
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {isPDF && (
          <Button variant="contained" onClick={handleOpenPDF}>
            Open
          </Button>
        )}
        <Button
          variant="contained"
          onClick={handleDownload}
          startIcon={<Download size={18} />}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default FilePreviewDialog;
